/**
 * Handlers for note-related operations
 */
import { updateTextAndSelectedText } from "../utils/stateUpdateUtils";

/**
 * Add note below part
 */
export const createAddNoteBelowPart = ({
  text,
  setTexts,
  setSelectedText,
  saveToHistory,
  isElementBeingEdited,
  setPendingChanges,
}) => {
  return () => {
    if (!text || !text.selectedContent || text.selectedContent.type !== "part")
      return;

    if (isElementBeingEdited) {
      setPendingChanges(true);
    }

    const selectedPartId = text.selectedContent.id;
    if (!selectedPartId) return;

    setTexts((prevTexts) =>
      prevTexts.map((t) => {
        if (t.id !== text.id) return t;

        const newPartsByType = Object.fromEntries(
          Object.entries(t.partsByType || {}).map(([typeName, typeData]) => {
            const updatedParts = typeData.parts.map((partObj) =>
              partObj.id === selectedPartId
                ? {
                    ...partObj,
                    note: partObj.note || "",
                  }
                : partObj
            );

            return [typeName, { ...typeData, parts: updatedParts }];
          })
        );

        return {
          ...t,
          partsByType: newPartsByType,
        };
      })
    );

    setSelectedText((prev) => {
      if (!prev) return prev;

      const updatedPartsByType = Object.fromEntries(
        Object.entries(prev.partsByType || {}).map(([typeName, typeData]) => {
          const updatedParts = typeData.parts.map((partObj) =>
            partObj.id === selectedPartId
              ? {
                  ...partObj,
                  note: partObj.note || "",
                }
              : partObj
          );

          return [typeName, { ...typeData, parts: updatedParts }];
        })
      );

      return {
        ...prev,
        partsByType: updatedPartsByType,
      };
    });

    saveToHistory();
  };
};
